import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import StateSiteUserPublisher from "./StateSiteUserPublisher";

export default function AllSiteUserPublisher() {
  const params = useParams();
  const userID = params.userID;
  const [allSiteUserPublisher, setAllSiteUserPublisher] = useState([]);

  useEffect(() => {
    getAllSiteUserPublisher();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllSiteUserPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllSiteUserPublisher =
      await sendRequestGetAllSiteUserPublisher(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllSiteUserPublisher) {
      return;
    }

    setAllSiteUserPublisher(resultSendRequestGetAllSiteUserPublisher);
  };

  const sendRequestGetAllSiteUserPublisher = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/site/user/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const generateTableAllSiteUserPublisher = () => {
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space m-0">
          <thead>
            <tr>
              <td>#</td>
              <td>شماره</td>
              <td>سایت</td>
              <td>وضعیت</td>
              <td>حالت</td>
              <td>تاریخ درج</td>
              <td>تاریخ آخرین بروزرسانی</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>
            {allSiteUserPublisher.map((siteUserPublisher, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{siteUserPublisher.usp_id}</td>
                  <td className="text-left">
                    {
                      <a target="_blank" href={siteUserPublisher.usp_url}>
                        {siteUserPublisher.usp_url}
                      </a>
                    }
                  </td>
                  <td>
                    {
                      StateSiteUserPublisher.statusSiteUserPublisherString()[
                        siteUserPublisher.usp_state
                      ]
                    }
                  </td>
                  <td>
                    {
                      StateSiteUserPublisher.getActiveSiteUserPublisherString()[
                        siteUserPublisher.usp_active
                      ]
                    }
                  </td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        siteUserPublisher.usp_created_at
                      ) +
                        " " +
                        siteUserPublisher.usp_created_at.split(" ")[1]
                    )}
                  </td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        siteUserPublisher.usp_updated_at
                      ) +
                        " " +
                        siteUserPublisher.usp_updated_at.split(" ")[1]
                    )}
                  </td>
                  <td>
                    <Link
                      to={`/user/manage/site-publisher/${siteUserPublisher.usp_id}`}
                      className="btn btn-info"
                    >
                      <i className="fa fa-info"></i>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  سایت های نمایش دهنده کاربر
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to={`/user/show-info-user/${userID}`}
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              <div>
                <p className="alert alert-warning">
                  در صورت تایید حداقل یکی از سایت نمایش دهنده کاربر اگر نقش
                  کاربر در حالت تبلیغ دهنده است نقش کاربر را به نمایش دهنده از
                  <Link
                    className="px-2"
                    to={`/user/show-info-user/${userID}`}
                    target="_blank"
                  >
                    اینجا
                  </Link>
                  تغییر بدهید.
                </p>
                {allSiteUserPublisher.length == 0 ? (
                  <></>
                ) : (
                  generateTableAllSiteUserPublisher()
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
